import React from 'react'
import { useDispatch } from 'react-redux'
import { showUploadSuccessModalFunc } from '../../../../config/redux/slice/transfereeUserSlice'

export default function UploadSuccessModal() {
  const dispatch = useDispatch()
  return (
    <div 
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-md" role="document">
    <div className="modal-content">
      <div className='formContainer'>
            <div style={{columnGap: '0.8rem'}} className='greeting d-flex justify-content-center align-items-center'>
                <i style={{fontSize: '1.5rem'}} className={`text-success mdi mdi-checkbox-marked-circle`}></i>
              <p style={{fontSize: '1.3rem'}} className={`text-success text-capitalize`}>
                Certificate Upload Successful
              </p>
            </div>
            <form className='mainForm'>
              <div className="row w-100 m-0">
                <div className='text-center mb-5' style={{color: '#31343D'}}>
            <p style={{lineHeight: '1.8rem'}}>A link will be sent to your bank representative's email and it will expire. within 24hrs</p>
        </div>
        <div className="col-md-12">
          <button 
            onClick={()=> dispatch(showUploadSuccessModalFunc({modal:false}))}
            type="button" 
            className="btn btn-outline-primary mb-4"
          >
              Close
          </button> 
        {/* <Spinner/> */}
      </div>
              </div>
            </form>
        </div>  
    </div>
  </div>
</div>
  )
}
